export enum LoanApplicationSteps {
  Parameters = "PARAMETERS",
  PersonalInformation = "PERSONAL_INFORMATION",
  Workplace = "WORKPLACE",
  Addresses = "ADDRESSES",
  DrawdownInformation = "DRAWDOWN_INFORMATION",
  CustomerAccount = "CUSTOMER_ACCOUNT",
  Success = "SUCCESS",
}
